new Swiper(".swiper",{
  loop: true,
  slidesPerView: 1,
  spaceBetween: 20,
  speed: 1000,
  autoplay: {
    delay: 5000,
  },
  breakpoints: {
    700: {
      slidesPerView: 2
    }
  }
});

let scrollPosition = 0;
$(".hamburger").on("click", function() {
  $(this).toggleClass("active");
  $(".side-wrap").fadeToggle();
  $(".side-wrap").css("top", $(".header").innerHeight() + "px");

  if ($(this).hasClass("active")) {
    // 現在のスクロール位置を保持
    scrollPosition = window.pageYOffset;
    $("body").css({
      position: "fixed",
      top: -scrollPosition + "px",
      width: "100%",
    });
  } else {
    // 固定解除してスクロール位置を戻す
    $("body").css({
      position: "",
      top: "",
      width: "",
    });
    window.scrollTo(0, scrollPosition);
  }
});